import DescriptionFieldTemplate from "./DescriptionField";

export default DescriptionFieldTemplate;